import React, { FC } from 'react'

import TelephoneInput from './TelephoneInput'
import ZipcodeInput from './ZipcodeInput'
import DateInput from './DateInput'
import ActivationCodeInput from './ActivationCodeInput'
import styles from './styles.module.scss'

type TextInputProps = {
  style?: React.CSSProperties
  fluid?: boolean
  label?: string
  placeholder: string
  value: string
  handleChange: (value: string) => void
  onFocus: () => void
  type?:
    | 'default'
    | 'date'
    | 'zipcode'
    | 'telephone'
    | 'activation-code'
    | 'alphanumeric'
  maxLength?: number
  error: boolean
  errorMessage: string
}

const TextInput: FC<TextInputProps> = ({
  style,
  label = '',
  placeholder = '',
  value,
  handleChange,
  onFocus,
  type = 'default',
  maxLength = 32,
  error = false,
  errorMessage = ''
}) => {
  const hasError = () => {
    return error ? 'error' : ''
  }

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    let { value: val } = e.target

    if (type === 'alphanumeric') {
      val = val.replace(/[^a-zA-Z0-9\s-]+/gi, '')
    }

    handleChange(val)
  }

  return (
    <div className={`field ${styles.text_input} ${hasError()}`}>
      <label htmlFor="date-input">{label}</label>
      <div className="ui input">
        {type === 'zipcode' && (
          <ZipcodeInput
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onFocus={onFocus}
          />
        )}
        {type === 'telephone' && (
          <TelephoneInput
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onFocus={onFocus}
          />
        )}
        {type === 'date' && (
          <DateInput
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onFocus={onFocus}
          />
        )}
        {type === 'activation-code' && (
          <ActivationCodeInput
            placeholder={placeholder}
            value={value}
            onChange={handleChange}
            onFocus={onFocus}
          />
        )}
        {(type === 'default' || type === 'alphanumeric') && (
          <input
            className={styles.text_input}
            style={style}
            placeholder={placeholder}
            type="text"
            maxLength={maxLength}
            value={value}
            onChange={onTextChange}
            onFocus={onFocus}
          />
        )}
        {error && <i className="fa fa-warning" />}
      </div>
      {error && errorMessage && (
        <div className={styles.error_message}>{errorMessage}</div>
      )}
    </div>
  )
}

export default TextInput
